<div id="programs" data-scroll>
    <div class="container-fluid mt-5 px-3 px-lg-5">
        <div class="row">
            <div class="col-12">
                <h2 class="home-title text-center">Spotlight</h2>
            </div>
        </div>

        <div class="row mx-auto navContainer">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" aria-current="page" id="convocation-btn" data-bs-toggle="collapse"
                        data-bs-target="#convocation" (click)="showCard(1)">
                        <i [ngClass]="getIconClass(album1Title)"></i> &nbsp;{{ album1Title }}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" aria-current="page" id="annual-btn" data-bs-toggle="collapse"
                        data-bs-target="#annual" (click)="showCard(2)">
                        <i [ngClass]="getIconClass(album2Title)"></i> &nbsp;{{ album2Title }}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" aria-current="page" id="sports-btn" data-bs-toggle="collapse"
                        data-bs-target="#sports" (click)="showCard(3)">
                        <i [ngClass]="getIconClass(album3Title)"></i> &nbsp;{{ album3Title }}
                    </a>
                </li>
            </ul>
        </div>

        <div class="row collapse px-5" id="convocation">
            <div class="col-12 col-md-6 mb-3" *ngFor="let item of convocation | slice:0:4">
                <img [src]="item" class="img-fluid rounded-4 shadow" [alt]="album1Title">
            </div>
            <div class="col-12 text-center mt-4 mb-3" *ngIf="convocation && convocation.length > 4">
                <a routerLink="/gallery" class="btn btn-view-more px-4 py-2 rounded-pill fw-bold shadow-sm">
                    View More &nbsp;<i class="fa-solid fa-arrow-right-long"></i>
                </a>
            </div>
        </div>

        <div class="row collapse px-5" id="annual">
            <div class="col-12 col-md-6 mb-3" *ngFor="let item of annual | slice:0:4">
                <img [src]="item" class="img-fluid rounded-4 shadow" [alt]="album2Title">
            </div>
            <div class="col-12 text-center mt-4 mb-3" *ngIf="annual && annual.length > 4">
                <a routerLink="/gallery" class="btn btn-view-more px-4 py-2 rounded-pill fw-bold shadow-sm">
                    View More &nbsp;<i class="fa-solid fa-arrow-right-long"></i>
                </a>
            </div>
        </div>

        <div class="row collapse px-5" id="sports">
            <div class="col-12 col-md-6 mb-3" *ngFor="let item of sports | slice:0:4">
                <img [src]="item" class="img-fluid rounded-4 shadow" [alt]="album3Title">
            </div>
            <div class="col-12 text-center mt-4 mb-3" *ngIf="sports && sports.length > 4">
                <a routerLink="/gallery" class="btn btn-view-more px-4 py-2 rounded-pill fw-bold shadow-sm">
                    View More &nbsp;<i class="fa-solid fa-arrow-right-long"></i>
                </a>
            </div>
        </div>

    </div>
</div>